import React from 'react';

export default function GridItem({ title, text, lead, i, icon }) {
    return <div className="grid-item">
        <embed src={i || i === 0 ? `${process.env.PUBLIC_URL}/home-grid/${i + 1}.svg` : icon } className="grid-item__icon"/>
        <h4 className="grid-item__title">{title}</h4>
        <p className="grid-item__text" dangerouslySetInnerHTML={{__html: lead ? `${lead} ${text}` : `${text}`}} />
    </div>
}